// ============================================================
// i18n catalog — ported verbatim from design/prototype/data.jsx
// ============================================================

export type Lang = "de" | "en";

export const I18N: Record<Lang, Record<string, string>> = {
  de: {
    "app.tagline": "Kommunales Spielflächen-Management",
    "nav.dashboard": "Dashboard",
    "nav.karte": "Karte",
    "nav.verwaltung": "Verwaltung",
    "nav.maengel": "Mängelprüfung",
    "nav.gruen": "Grünflächenverknüpfung",
    "menu.account": "Account",
    "menu.help": "Hilfe",
    "menu.logout": "Abmelden",
    "menu.admin": "Admin-Panel",
    "common.login": "Anmelden",
    "common.cancel": "Abbrechen",
    "common.save": "Speichern",
    "common.apply": "Anwenden",
    "common.delete": "Löschen",
    "common.edit": "Bearbeiten",
    "common.add": "Hinzufügen",
    "common.done": "Fertig",
    "common.search": "Suchen…",
    "common.noMatches": "Keine Treffer",
    "common.test": "Verbindung testen",
    "common.export": "Exportieren",
    "common.filter": "Filter",
    "common.close": "Schließen",
    "common.back": "Zurück",
    "common.confirm": "Bestätigen",
    "login.title": "Willkommen zurück",
    "login.sub": "Melden Sie sich an, um auf Ihre Projekte zuzugreifen.",
    "login.user": "Benutzername oder E-Mail",
    "login.pass": "Passwort",
    "login.forgot": "Passwort vergessen?",
    "login.demo": "Demo-Zugänge",
    "login.signin": "Anmelden",
    "forgot.title": "Passwort zurücksetzen",
    "forgot.sub": "Wir senden Ihnen einen Link zum Zurücksetzen.",
    "forgot.send": "Link senden",
    "forgot.sent": "E-Mail gesendet — prüfen Sie Ihr Postfach.",
    "dash.title": "Projektübersicht",
    "dash.sub": "Zentrales Management für kommunale Spielflächen.",
    "dash.newproject": "Neues Projekt",
    "dash.open": "Projekt öffnen",
    "dash.guest": "Gast",
    "dash.metrics": "Kennzahlen",
    "dash.chart": "Diagramm",
    "dash.table": "Tabelle",
    "dash.array": "Auswahl",
    "dash.composer": "Diagramm-Komposer",
    "dash.citywide": "Stadtweit",
    "dash.playgrounds": "Spielplätze",
    "dash.area": "Gesamtfläche",
    "dash.perchild": "pro Kind",
    "dash.district": "Bezirk",
    "dash.supplyindex": "Versorgungsindex",
    "dash.compare": "Vergleichen",
    "dash.layout": "Layout",
    "acc.title": "Kontoeinstellungen",
    "acc.sub": "Verwalten Sie Ihre Daten und Sicherheit.",
    "acc.photo": "Profilbild",
    "acc.upload": "Hochladen",
    "acc.username": "Benutzername",
    "acc.display": "Anzeigename",
    "acc.email": "E-Mail-Adresse",
    "acc.security": "Sicherheit",
    "acc.newpass": "Neues Passwort",
    "acc.confirmpass": "Passwort bestätigen",
    "acc.language": "Sprache",
    "acc.danger": "Gefahrenzone",
    "acc.deleteacc": "Konto löschen",
    "admin.title": "Administration",
    "admin.sub": "Benutzer, Datenverbindungen und Layer-Styling verwalten.",
    "admin.users": "Benutzerverwaltung",
    "admin.projects": "Projekteinstellungen",
    "admin.layers": "Layer-Verwaltung",
    "admin.valuerel": "Value-Relations",
    "footer.imprint": "Impressum",
    "footer.privacy": "Datenschutz",
    "footer.contact": "Kontakt",
    "map.layers": "Ebenen",
    "map.styling": "Darstellung",
    "map.startedit": "Bearbeitung starten",
    "role.admin": "Administrator",
    "role.editor": "Bearbeiter",
    "role.viewer": "Betrachter",
    "role.guest": "Gast",
  },
  en: {
    "app.tagline": "Municipal play-area management",
    "nav.dashboard": "Dashboard",
    "nav.karte": "Map",
    "nav.verwaltung": "Administration",
    "nav.maengel": "Defect Audit",
    "nav.gruen": "Green-Space Linkage",
    "menu.account": "Account",
    "menu.help": "Help",
    "menu.logout": "Log out",
    "menu.admin": "Admin Panel",
    "common.login": "Log in",
    "common.cancel": "Cancel",
    "common.save": "Save",
    "common.apply": "Apply",
    "common.delete": "Delete",
    "common.edit": "Edit",
    "common.add": "Add",
    "common.done": "Done",
    "common.search": "Search…",
    "common.noMatches": "No matches",
    "common.test": "Test connection",
    "common.export": "Export",
    "common.filter": "Filter",
    "common.close": "Close",
    "common.back": "Back",
    "common.confirm": "Confirm",
    "login.title": "Welcome back",
    "login.sub": "Sign in to access your projects.",
    "login.user": "Username or email",
    "login.pass": "Password",
    "login.forgot": "Forgot password?",
    "login.demo": "Demo access",
    "login.signin": "Sign in",
    "forgot.title": "Reset password",
    "forgot.sub": "We'll send you a reset link.",
    "forgot.send": "Send link",
    "forgot.sent": "Email sent — check your inbox.",
    "dash.title": "Project overview",
    "dash.sub": "Central management for municipal play areas.",
    "dash.newproject": "New project",
    "dash.open": "Open project",
    "dash.guest": "Guest",
    "dash.metrics": "Key figures",
    "dash.chart": "Chart",
    "dash.table": "Table",
    "dash.array": "Selection",
    "dash.composer": "Chart composer",
    "dash.citywide": "Citywide",
    "dash.playgrounds": "Playgrounds",
    "dash.area": "Total footprint",
    "dash.perchild": "per child",
    "dash.district": "District",
    "dash.supplyindex": "Supply index",
    "dash.compare": "Compare",
    "dash.layout": "Layout",
    "acc.title": "Account settings",
    "acc.sub": "Manage your information and security.",
    "acc.photo": "Profile picture",
    "acc.upload": "Upload",
    "acc.username": "Username",
    "acc.display": "Display name",
    "acc.email": "Email address",
    "acc.security": "Security",
    "acc.newpass": "New password",
    "acc.confirmpass": "Confirm password",
    "acc.language": "Language",
    "acc.danger": "Danger zone",
    "acc.deleteacc": "Delete account",
    "admin.title": "Administration",
    "admin.sub": "Manage users, data connections and layer styling.",
    "admin.users": "User management",
    "admin.projects": "Project settings",
    "admin.layers": "Layer management",
    "admin.valuerel": "Value relations",
    "footer.imprint": "Imprint",
    "footer.privacy": "Privacy",
    "footer.contact": "Contact",
    "map.layers": "Layers",
    "map.styling": "Styling",
    "map.startedit": "Start editing",
    "role.admin": "Admin",
    "role.editor": "Editor",
    "role.viewer": "Viewer",
    "role.guest": "Guest",
  },
};

export function translate(lang: Lang, key: string): string {
  return I18N[lang]?.[key] ?? I18N.de[key] ?? key;
}

// Localized display name for an internal role id (guest|viewer|editor|admin).
// Internal ids stay English everywhere; only the display is localized.
export function roleLabel(lang: Lang, role: string): string {
  return translate(lang, `role.${role}`);
}
